<template>
  <div id="app">
    <hi-container>
      <router-view></router-view>
    </hi-container>
  </div>
</template>

<script>
import bus from "./bus";
export default {
  name: "App",
  data() {
    return {
      // Default values
      theme: "Start",
      color: "start",
    };
  },
  created() {},
};
</script>

<style lang="scss">
//  <transition name="fade" mode="out-in">
</style>
